<script lang="ts" setup>

  type Props = {
    items: string[]
    selectedIndex: number
  }
  const props = defineProps<Props>()

  const emit = defineEmits<{
    (e: 'on-input', i: number): void
  }>()

</script>

<template>
  <div class="c-radio-select">
    <span
      v-for="(item, index) in props.items"
      :key="index"
      :class="{ active: props.selectedIndex === index }"
      @click="emit('on-input', index)"
    >
      <span class="dot" />{{ item }}</span>
  </div>
</template>

<style scoped>

.c-radio-select {
  display: flex;
  margin-top: 2.25em;

  span {
    position: relative;
    display: inline-block;
    align-items: center;
    margin-right: 1em;
    color: var(--color-secondary);
    cursor: pointer;
    font-family: Open-Sans, sans-serif;
    font-size: 1.125em;
    font-weight: 600;
    line-height: 18px;
    opacity: 0.8;
    user-select: none;

    .dot {
      display: inline-block;
      width: 18px;
      height: 18px;
      border: 1px solid var(--color-secondary);
      border-radius: 100%;
      margin-right: 0.5em;
      content: "";
      opacity: 0.5;
    }

    &.active::after {
      position: absolute;
      top: 5px;
      left: 5px;
      display: flex;
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background-color: var(--color-primary);
      content: "";
    }
  }
}
</style>
